/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserPointsInfoRespVo } from './UserPointsInfoRespVo';
import {
    UserPointsInfoRespVoFromJSON,
    UserPointsInfoRespVoFromJSONTyped,
    UserPointsInfoRespVoToJSON,
    UserPointsInfoRespVoToJSONTyped,
} from './UserPointsInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseUserPointsInfoRespVo
 */
export interface ResponseUserPointsInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserPointsInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserPointsInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {UserPointsInfoRespVo}
     * @memberof ResponseUserPointsInfoRespVo
     */
    data?: UserPointsInfoRespVo;
}

/**
 * Check if a given object implements the ResponseUserPointsInfoRespVo interface.
 */
export function instanceOfResponseUserPointsInfoRespVo(value: object): value is ResponseUserPointsInfoRespVo {
    return true;
}

export function ResponseUserPointsInfoRespVoFromJSON(json: any): ResponseUserPointsInfoRespVo {
    return ResponseUserPointsInfoRespVoFromJSONTyped(json, false);
}

export function ResponseUserPointsInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserPointsInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserPointsInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseUserPointsInfoRespVoToJSON(json: any): ResponseUserPointsInfoRespVo {
    return ResponseUserPointsInfoRespVoToJSONTyped(json, false);
}

export function ResponseUserPointsInfoRespVoToJSONTyped(value?: ResponseUserPointsInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserPointsInfoRespVoToJSON(value['data']),
    };
}

